export var BenchmarkDirectionType;
(function (BenchmarkDirectionType) {
    BenchmarkDirectionType[BenchmarkDirectionType["Upwards"] = 0] = "Upwards";
    BenchmarkDirectionType[BenchmarkDirectionType["Downwards"] = 1] = "Downwards";
    BenchmarkDirectionType[BenchmarkDirectionType["Middle"] = 2] = "Middle";
})(BenchmarkDirectionType || (BenchmarkDirectionType = {}));
